'use client';

import { AppDataProvider } from '@/lib/data-context';
import PostHogProvider from '@/components/PostHogProvider';
import VersionChecker from '@/components/VersionChecker';
import { ToastProvider } from '@/components/Toast';
import { CommandPaletteProvider } from '@/components/CommandPalette';
import { PatientPeekProvider } from '@/components/PatientPeek';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AppDataProvider>
      <ToastProvider>
        <CommandPaletteProvider>
          <PatientPeekProvider>
            {children}
            <PostHogProvider />
            <VersionChecker />
          </PatientPeekProvider>
        </CommandPaletteProvider>
      </ToastProvider>
    </AppDataProvider>
  );
}
